import { SafeHtml } from '@angular/platform-browser';

export class DocumentoModel {

  id?: number;
  idCfc?: number;
  cfcCnpj?: string;
  cnpjCfc?: string;
  nome?: string;
  html?: string;
  idTipoDocumento?: number;
  editavel?: boolean;
  cfcNomeFantasia?: string;
  safeHtml?: SafeHtml;

  constructor(options: DocumentoModel = {}) {
    this.id = options.id || null;
    this.idCfc = options.idCfc || null;
    this.cfcCnpj = options.cfcCnpj || null;
    this.cnpjCfc = options.cnpjCfc || null;
    this.nome = options.nome || null;
    this.html = options.html || null;
    this.idTipoDocumento = options.idTipoDocumento || null;
    this.editavel = options.editavel || true;
    this.cfcNomeFantasia = options.cfcNomeFantasia || null;
    this.safeHtml = options.safeHtml || null;
  }
}
